import Button from "@mui/material/Button";
import { useNavigate, useParams } from "react-router-dom";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { useMemo } from "react";
import GuideListMenu from "./GuideListMenu";
import { useInternationalizedArticles } from "../data/internationalizedArticles";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * The guide category.
 */
function GuideCategory() {
  const navigate = useNavigate();
  const routeParams = useParams();
  const { categorySlug } = routeParams;
  const { categories, articles } = useInternationalizedArticles();
  const { t } = useTranslation("helpCenter");

  const category = useMemo(
    () => categories.find((cat) => cat.slug === categorySlug),
    [categories, categorySlug]
  );
  const guides = useMemo(
    () => articles.filter((guide) => guide.categorySlug === categorySlug),
    [articles, categorySlug]
  );

  const handleGoBack = () => {
    navigate(-1);
  };

  if (!category) {
    return (
      <div className="flex flex-col items-center p-24 sm:p-40 container">
        <Typography variant="h4" color="error">
          Category not found
        </Typography>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center p-24 sm:p-40 container">
      <div className="flex flex-col w-full max-w-4xl">
        <div className="sm:mt-32">
          <Button
            onClick={handleGoBack}
            color="secondary"
            startIcon={
              <FuseSvgIcon>heroicons-outline:arrow-narrow-left</FuseSvgIcon>
            }
          >
            {t("BACK_TO_GUIDES_AND_RESOURCES")}
          </Button>
        </div>
        <div className="mt-8 text-4xl sm:text-7xl font-extrabold tracking-tight leading-tight">
          {category.title}
        </div>
        {category.description && (
          <Typography color="text.secondary" className="mt-8 sm:text-xl">
            {category.description}
          </Typography>
        )}
        <div className="mt-32 sm:mt-48">
          <GuideListMenu list={guides} categorySlug={categorySlug} />
        </div>
      </div>
    </div>
  );
}

export default GuideCategory;
